export const GET_NAME_JOB = 'GET_NAME_JOB';
export const GET_LIST_MENU_JOB = 'GET_LIST_MENU_JOB';
export const GET_LIST_JOB_ID = 'GET_LIST_JOB_ID';
export const GET_DETAIL_JOB = 'GET_DETAIL_JOB';
export const GET_INFO_DETAIL_JOB = 'GET_INFO_DETAIL_JOB';
export const GET_COMMENT_ID_JOB = 'GET_COMMENT_ID_JOB'
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const ADD_COMMENT = 'ADD_COMMENT';